import { api } from '@services';

import CustomField, {
  ICustomField,
  ICustomFieldApiModel,
} from '@models/CustomField.model';

const indexCustomField = async (): Promise<ICustomField[]> => {
  const { data: customFields } = await api.get<ICustomFieldApiModel[]>(
    '/customFields',
  );

  return CustomField.arrayFromApiModel(customFields);
};

export { indexCustomField };
